/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EvaluationDimension } from './evaluationDimension';

export type GradingConfigSnapshotResponseEvalDimensions = { [key: string]: EvaluationDimension };
